import type { ReactElement, ReactNode } from 'react';

export interface Definition {
  term: string;
  value: ReactNode;
  /** Renders the value in tabular monospace (§3): money, meters, dates, ids. */
  numeric?: boolean;
}

export interface DefinitionListProps {
  items: Definition[];
  /** Announced to assistive technology when the list has no visible heading. */
  label?: string;
}

/**
 * The one term/value list in the product.
 *
 * A row whose value is absent is the CALLER's decision to omit — this component
 * renders what it is given and never substitutes an em dash for a missing
 * value, because "not supplied" and "zero" are different facts.
 */
export function DefinitionList({ items, label }: DefinitionListProps): ReactElement | null {
  if (items.length === 0) return null;
  return (
    <dl className="definition-list" {...(label === undefined ? {} : { 'aria-label': label })}>
      {items.map((item) => (
        <div key={item.term} className="definition-list__row">
          <dt>{item.term}</dt>
          <dd className={item.numeric === true ? 'numeric' : undefined}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
